import apiRequest from './handler';

const DigioService = {
    createKycRequest: async (setIsAuthenticated, navigate) => {
        try {
            return apiRequest(
                '/reseller/digio/create_kyc_request',
                'POST',
                null,
                true,
                setIsAuthenticated,
                navigate,
            );
        } catch (error) {
            console.error('Error creating kyc request:', error);
            throw error;
        }
    },

    verifyKycRequest: async (kycId, setIsAuthenticated, navigate) => {
        try {
            return apiRequest(
                `/reseller/digio/verify_kyc_request?kyc_id=${kycId}`,
                'POST',
                null,
                true,
                setIsAuthenticated,
                navigate,
            );
        } catch (error) {
            console.error('Error verifying kyc request:', error);
            throw error;
        }
    },

    createSignRequest: async (setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/reseller/digio/create_sign_request`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching enquiry options:', error);
            throw error;
        }
    },

    validateDocumentSignature: async (docId, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/reseller/digio/document?docId=${docId}`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error validating document signature:', error);
            throw error;
        }
    },
};

export default DigioService;
